// @format
import PropTypes from 'prop-types';

const SelectOption = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});

export default {
  propType: SelectOption,
};
